import { Resource } from './resource';
import { Attachment, FilePurpose } from '../models';
import type { PresignedUrl } from '../models';

export class Files extends Resource {
  resourcePath = 'v1/files';

  async create(
    file: File,
    options: {
      purpose?: FilePurpose;
      attachment?: Attachment;
    },
  ): Promise<{ attachment: Attachment; presignedUrl: PresignedUrl }> {
    const response = await this.api.post(this.path('presign'), {
      data: {
        name: file.name,
        mime_type: file.type,
        size: file.size,
        purpose: options.purpose,
      },
    });

    const attachment = options.attachment || Attachment.fromJson(response.data.attachment);
    if (options.attachment) {
      attachment.updateFromJson(response.data.attachment);
    }
    attachment._file = file;

    return {
      attachment,
      presignedUrl: response.data.presigned_url,
    };
  }
}
